import { OrderStatusType } from "@models/order";

export interface OrderTransitionAction {
    key: string;
    label: string;
    targetStatus: OrderStatusType;
    requiresShipment: boolean;
}

// Ruling O1 names it "Mark Processed". Exported for the Orders list's bulk
// action (#473), which applies the same payment rule per order.
export const MARK_PROCESSING: OrderTransitionAction = {
    key: "processing",
    label: "Mark Processed",
    targetStatus: OrderStatusType.Processing,
    requiresShipment: false,
};

const MARK_SHIPPED: OrderTransitionAction = {
    key: "shipped",
    label: "Mark Shipped",
    targetStatus: OrderStatusType.Shipped,
    requiresShipment: true,
};

const MARK_DELIVERED: OrderTransitionAction = {
    key: "delivered",
    label: "Mark Delivered",
    targetStatus: OrderStatusType.Delivered,
    requiresShipment: false,
};

const CANCEL: OrderTransitionAction = {
    key: "cancel",
    label: "Cancel Order",
    targetStatus: OrderStatusType.Cancelled,
    requiresShipment: false,
};

export const ALLOWED_TRANSITIONS: Record<
    OrderStatusType,
    OrderTransitionAction[]
> = {
    [OrderStatusType.None]: [],
    [OrderStatusType.Received]: [MARK_PROCESSING, CANCEL],
    [OrderStatusType.Processing]: [MARK_SHIPPED, CANCEL],
    [OrderStatusType.Shipped]: [MARK_DELIVERED],
    [OrderStatusType.Delivered]: [],
    [OrderStatusType.Cancelled]: [],
};
